/**
 * One reset for the whole procurement demo: the Pillar procurement suite plus
 * the replenishment demo. Wired into the hidden Cmd+K "Reset demo"
 * command via `@/demo/command/demo-catalog`. Each area owns its own store; this
 * just calls every area's reset.
 */

import { resetFulfillStatuses } from '@/pages/authenticated/procurement/demo/fulfillStore';
import { resetAgentsDemo } from './pages/agents/agents-store';
import { resetBuyerBoardDemo } from './pages/buyer-board/buyer-board-store';
import { resetComplianceDemo } from './pages/compliance/compliance-store';
import { resetContractsDemo } from './pages/contracts/contracts-store';
import { resetBomDemo } from './pages/forecast/bom-store';
import { resetForecastDemo } from './pages/forecast/forecast-store';
import { resetOverviewDemo } from './pages/overview/overview-store';
import { resetRequestsDemo } from './pages/requests/requests-store';
import { resetRiskDemo } from './pages/risk/risk-store';
import { resetSourcingDemo } from './pages/sourcing/sourcing-store';
import { resetMaterialsDemo } from './pages/suppliers/materials-store';
import { resetOnboardingDemo } from './pages/suppliers/onboarding-store';

export function resetProcurementDemo(): void {
  resetOverviewDemo();
  resetRequestsDemo();
  resetMaterialsDemo();
  resetOnboardingDemo();
  resetSourcingDemo();
  resetContractsDemo();
  resetComplianceDemo();
  resetRiskDemo();
  resetForecastDemo();
  resetBomDemo();
  resetBuyerBoardDemo();
  resetAgentsDemo();
  resetFulfillStatuses();
}
